/**
 * Devuelve la fecha local en formato YYYY-MM-DD.
 */
export function fechaLocalYMD(date: string | Date = new Date()): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('sv-SE');
}

/**
 * Formatea una cadena ISO/datetime como hora legible en Costa Rica (HH:MM).
 * Fuerza timeZone 'America/Costa_Rica' para evitar desfases por UTC naive.
 */
export function formatTimeCR(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('es-CR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Costa_Rica',
  });
}

/**
 * Formatea una cadena ISO/datetime como fecha legible en Costa Rica.
 * Fuerza timeZone 'America/Costa_Rica' para evitar desfases por UTC naive.
 */
export function formatDateCR(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('es-CR', {
    timeZone: 'America/Costa_Rica',
  });
}

/**
 * Devuelve el día operativo en formato YYYY-MM-DD.
 * El día operativo es la fecha calendario Costa Rica (00:00–23:59).
 * Alineado con backend: dia_operativo() = fecha CR pura.
 */
export function diaOperativo(): string {
  return fechaLocalYMD(new Date());
}
